import L from "leaflet";
import { onDocumentReady } from "@story/story_assets/utils";

const API_KEY = 'S7gRUKCVB8aFoWneRj0XSeIKbGEtlF1oEwblsacjlG0';

function createMap(element) {
	let position = JSON.parse(element.getAttribute("data-smap-center"));
	let zoom = element.getAttribute("data-smap-zoom");

	const map = L.map(element).setView(position, zoom);
	map.attributionControl.setPrefix(false);

	L.tileLayer(`https://api.mapy.cz/v1/maptiles/basic/256@2x/{z}/{x}/{y}?apikey=${API_KEY}`, {
		minZoom: 0,
		maxZoom: 19,
		attribution: '<a href="https://api.mapy.cz/copyright" target="_blank">&copy; Seznam.cz a.s. a další</a>',
	}).addTo(map);

	L.marker(position, {
		icon: L.icon({
			iconUrl: RAILS_ASSET_URL("layout/pin2_orange.png"),
			iconSize: [43 / 2, 86 / 2],
			iconAnchor: [43 / 4, 86 / 2],
		})
	}).addTo(map);

};

onDocumentReady(() => {
	for (const element of document.querySelectorAll("[data-smap]")) {
		createMap(element);
	}
});